import { useEffect, useState } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { ReactComponent as IconClose } from 'assets/icons/closeIcon.svg'

const TagsBox = ({
  placeholder,
  name,
  handleValueChange,
  data,
  showValidationErrors,
  error,
}) => {
  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState('')

  const onChangeInput = (e) => {
    setInputValue(e.target.value)
  }

  const onClickInput = (e) => {
    if (isEmpty(inputValue)) return

    if (['Tab', 'Enter', ' ', ','].includes(e.key)) {
      setTags([...tags, inputValue])
      setInputValue('')
    }
  }

  const onBlurInput = () => {
    if (isEmpty(inputValue)) return

    setInputValue('')
    setTags([...tags, inputValue])
  }

  const onClickRemoveButton = (idx) => {
    const newTagsArray = tags.filter((_, index) => index !== idx)
    setTags(newTagsArray)
  }

  useEffect(() => {
    handleValueChange(tags)
    // eslint-disable-next-line
  }, [tags.length])

  useEffect(() => {
    setTags(data)
    // eslint-disable-next-line
  }, [])

  return (
    <div
      className={cn('tagsBox', {
        '-isAnyTags': !isEmpty(tags),
        '-error': showValidationErrors && error,
      })}
    >
      <section className="tagsBox__tags-section">
        {tags?.map((tag, idx) => (
          <div className="tagsBox__tag" key={idx}>
            <p className="tagsBox__name">{tag}</p>
            <button
              className="tagsBox__button-remove"
              type="button"
              onClick={() => onClickRemoveButton(idx)}
            >
              <IconClose />
            </button>
          </div>
        ))}

        <input
          className="tagsBox__input"
          name={name}
          value={inputValue}
          onChange={onChangeInput}
          onKeyDown={(e) => onClickInput(e)}
          onBlur={onBlurInput}
        />
        <label
          className={cn('tagsBox__label', {
            '-isLabel': !isEmpty(tags) || !isEmpty(inputValue),
          })}
        >
          {placeholder}
        </label>
      </section>
    </div>
  )
}

TagsBox.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  handleValueChange: PropTypes.func,
  data: PropTypes.array,
  showValidationErrors: PropTypes.bool,
  error: PropTypes.string,
}

TagsBox.defaultProps = {
  placeholder: '',
  name: '',
  handleValueChange: () => {},
  data: [],
}

export default TagsBox
